import React, { useEffect, useState } from "react";
import DateAndLocation from "./date-and-location";
import FeesTable from "./fees-table";
import {
  formatDate,
  formatFromToDate,
  getFeesList,
  getLocation,
  getFormattedDateRange,
} from "../../../utils/util";
import { t } from "i18next";
import { STRING_CONSTANT } from "../../../constants/constants";
import { useSelector } from "react-redux";

const ConferenceRegistrationDetails = (props) => {
  const { conferenceDetails, conferenceFeesList, isPaidRegistration, conferenceConfiguration } = props;

  const { kuConfiguration } = useSelector((state) => state.conferenceDetails);
  const [aed, setAed] = useState(1);
  useEffect(() => {
    if (kuConfiguration?.aed) {
      const kuAed = Number(kuConfiguration.aed);
      if (!isNaN(kuAed)) {
        setAed(kuAed);
      }
    }
  }, [kuConfiguration]);

  return (
    <div className="col-lg-8">
      <h2 className="mb-4 color-brand">{conferenceDetails?.title}</h2>
      <div
        className="conference-description"
        dangerouslySetInnerHTML={{
          __html: conferenceDetails?.description,
        }}
      />

      <div className="d-lg-flex justify-content-between border border-light bg-light p-3 rounded mb-5">
        <DateAndLocation
          label={t("date")}
          fieldValue={getFormattedDateRange(
            conferenceDetails?.fromDate,
            conferenceDetails?.toDate
          )}
          iconClass={"fa fa-calendar-alt"}
        />
        <DateAndLocation
          label={t("location")}
          fieldValue={`${getLocation(
            conferenceDetails?.street,
            conferenceDetails?.city,
            conferenceDetails?.country
          )}`}
          iconClass={"fa fa-location-dot"}
        />
      </div>

      <FeesTable
        title={t("registration-fees")}
        feesList={getFeesList(conferenceFeesList?.items, true,isPaidRegistration)}
        isMandatoryRegistration={true}
        conferenceDetails={conferenceDetails}
      />
      <div className="row mb-3">
        <div className="col-md-4">
          <p>
            {conferenceDetails?.earlyBirdCutoffDate ? (
              <span>
                <strong>{t("early-bird-date")}</strong>{" "}
                {formatDate(conferenceDetails?.earlyBirdCutoffDate)}
              </span>
            ) : (
              STRING_CONSTANT.BLANK
            )}
          </p>
        </div>
        <div className="col-md-8">
          <p>
            <span>{conferenceConfiguration?.earlyBirdMessage}</span>
          </p>
        </div>
      </div>
      <FeesTable
        title={t("optional-subscription-fees")}
        feesList={getFeesList(conferenceFeesList?.items, false)}
        conferenceDetails={conferenceDetails}
        aed={aed}
      />
   </div>
  );
};

export default ConferenceRegistrationDetails;
